export const Types = {
  showHeader: 'header/SHOW_HEADER'
}

export function showHeader (show = false) {
  return {
    type: Types.showHeader,
    payload: { show }
  }
}
